import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';

class DeleteCategoryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.otherCategories[0].id
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }


  render() {
    return (
      <Dialog
          title={"Delete \"" + this.props.category.title + '"'}
          actions={[<FlatButton
        label="Cancel"
        primary={false}
        onClick={this.props.onDismiss}
      />,
      <FlatButton
        label="Delete"
        primary={true}
        onClick={this.handleDelete}
      />]}
          modal={true}
          open={true}
        >
          This category contains {this.props.numRelatedItems} items. Please choose the category where these items will be moved after this one is deleted. <br />
          <SelectField ref="category" style={{width: 300}} value={this.state.value} onChange={this.handleChange}>
            {
              this.props.otherCategories.map((c) => <MenuItem key={c.id} value={c.id} primaryText={c.title} /> )
            }
          </SelectField>
      </Dialog>
    );
  }

  handleChange(e, i, value) {
    this.setState({value: value});
  }

  handleDelete() {
    this.props.onDelete(this.props.category.id, this.refs.category.props.value)
    this.props.onDismiss();
  }

}

DeleteCategoryModal.propTypes = {
  numRelatedItems: PropTypes.number.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  category: PropTypes.shape({
    title: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }),
  otherCategories: PropTypes.array
}

export default DeleteCategoryModal;
